export default __webpack_public_path__ + "static/media/jatin-bhardwaj.a29c5ed2.JPG";